import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/token";

export default function ReviewProductOnHold({
  show,
  handleClose,
  inholdproductId,
}) {
  const [inholdproduct, setInholdproduct] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    corrective_measure_id: "",
    effectiveness_note: "",
    accepted_qty: "",
    rejected_qty: "",
  });

  const resetForm = () => {
    setFormData({
     corrective_measure_id: "",
    effectiveness_note: "",
    accepted_qty: "",
    rejected_qty: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const fetchInholdproduct = async () => {
    const token = getAuthToken();
    if (!token || !inholdproductId) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/supervisor/getinholdproduct/${inholdproductId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.success) {
        const data = response.data.in_hold_product;
        setInholdproduct(Array.isArray(data) ? data[0] : data);
      } else {
        setInholdproduct(null);
      }
    } catch (err) {
      toast.error("Failed to fetch product details");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token || !inholdproduct) return;
    const payload = {
      corrective_measure_id: formData.correctiveMeasure,
      effectiveness_note: formData.measureEffectiveness,
      accepted_qty: formData.qtyAccepted,
      rejected_qty: formData.qtyRejected,
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/storeinholdproduct/${inholdproductId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data?.message) {
        toast.success(response.data.message);
        resetForm();
        handleClose();
      }
    } catch (err) {
      toast.error("Failed to submit review");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && inholdproductId) {
      fetchInholdproduct();
    }
  }, [show, inholdproductId]);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      centered
      className="font_family"
    >
     {
        loading ? (
            <Loader/>
        ):(
             <Modal.Body className="p-4">
        <h5 className="fw-bold mb-3">Review Product on Hold</h5>
        {inholdproduct && (
          <Card className="bg-light border-0 shadow-sm p-3 mb-4">
            <Row>
              <Col md={6}>
                <p>
                  <strong>Product:</strong>{" "}
                  {inholdproduct?.product?.name}
                </p>
                <p>
                  <strong>Machine Code:</strong>{" "}
                  {inholdproduct?.machine?.machine_code}
                </p>
              </Col>
              <Col md={6}>
                <p>
                  <strong>In Hold:</strong>{" "}
                  {inholdproduct?.nc_hold}
                </p>
                <p>
                  <strong>Rejected:</strong>{" "}
                  {inholdproduct?.nc_rejected}
                </p>
              </Col>
            </Row>
          </Card>
        )}

        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Corrective Measure</Form.Label>
            <Form.Select
              name="correctiveMeasure"
              value={formData.correctiveMeasure}
              onChange={handleChange}
            >
              <option value="">Select Measure</option>
              <option value="Rework">Rework</option>
              <option value="Repair">Repair</option>
              <option value="Scrap">Scrap</option>
              <option value="Return to Vendor">Return to Vendor</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Measure Effectiveness</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="measureEffectiveness"
              value={formData.measureEffectiveness}
              onChange={handleChange}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Quantity Accepted</Form.Label>
                <Form.Control
                  type="number"
                  name="qtyAccepted"
                  value={formData.qtyAccepted}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Quantity Rejected</Form.Label>
                <Form.Control
                  type="number"
                  name="qtyRejected"
                  value={formData.qtyRejected}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
        )
     }

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit} disabled={loading}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}